module.exports = __webpack_public_path__ + "static/media/rezi.f68f3a99.png";